<div class="modal-header" appCustomAutofocus>
    <h3>Initialize to Vista</h3>
</div>
<div class="modal-body">
    <div *ngIf="alert.msg != null" class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert" [innerHTML]="alert.msg" [style.white-space]="'pre-line'"></div>
    <div class="alert alert-info" *ngIf="alert.msg == null" role="alert">Initializing this employee will create the HR Resource for this record, migrate all attachments and submitted information to Vista.</div>
    <div class="alert alert-warning" *ngIf="formData.futureDate" role="alert">Since hire date is a future date, active check boxes will not be updated in Vista HR or PR.</div>
    <div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>HR Company <span style="color:red;">*</span></strong>
                <ng-select *ngIf="!employee.IsRehire"
                           [(ngModel)]="formData.HRCo"
                           bindLabel="CompanyName"
                           [searchable]="true"
                           [clearable]="false"
                           [disabled]="employee.IsRehire || expectHRCo"
                           (change)="hrcoUpdate()"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let hrCompany of hrCompanies" [value]="hrCompany">{{hrCompany.CompanyName}}</ng-option>
                </ng-select>
                <div *ngIf="employee.IsRehire">
                    <input class="form-control" type="text" value="{{formData.HRCo.HRCo}}" disabled />
                </div>
            </div>
            <div class="col-lg-4">
                <strong>Expected Hire Date <span style="color:red;">*</span></strong>
                <div class="input-group">
                    <input type="text"
                           class="form-control"
                           bsDatepicker
                           #fromdp="bsDatepicker"
                           [(ngModel)]="formData.hireDate"
                           [outsideClick]="true"
                           (ngModelChange)="hireDateChange()"
                           [bsConfig]="datePickerOptions"
                           [readonly]="mobileMode"
                           style="background-color:#ffffff">
                    <div class="input-group-append">
                        <button type="button" class="btn btn-outline-secondary"
                                (click)="fromdp.show()"
                                [attr.aria-expanded]="fromdp.isOpen">
                            <i class="modus-icons align-bottom">calendar</i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <strong>EEOC Gender <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.Gender"
                           [searchable]="true"
                           [clearable]="false"
                           [required]
                           dropdownPosition="bottom">
                    <ng-option value="M">M - Male</ng-option>
                    <ng-option value="F">F - Female</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>Auto Generate HR Ref</strong>
                <input class="ml-1" type="checkbox" style="width:30px;height:30px;" [disabled]="formData.hrefCB || employee.IsRehire || formData.expectHRRef" [(ngModel)]="formData.autoRef" (ngModelChange)="autoRefChange()" />
            </div>
            <div class="col-lg-4">
                <strong>HR Ref <span style="color:red;">*</span></strong>
                <input type="number" class="form-control" [(ngModel)]="formData.hrRef" [disabled]="formData.autoRef  || employee.IsRehire || formData.expectHRRef" (ngModelChange)="checkMaxLength()" [ngClass]="{'is-invalid': formData.hrRefDisable}" />
            </div>
            <div class="col-lg-4">
                <strong>Race <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.Race"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of raceList" [value]="data.Race">{{data.Race}} - {{data.Description}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>Hourly / Salary Amt.</strong>
                <input currencyMask [options]="options" type="text" class="form-control" [(ngModel)]="formData.Wage" />
            </div>
            <div class="col-lg-4" *ngIf="oNInitHirestoPayroll">
                <strong>PR Employee <span style="color:red;" *ngIf="!employee.IsRehire">*</span></strong>
                <input [(ngModel)]="formData.PREmployee" type="number" class="form-control" [disabled]="formData.PREmployeeDisable || formData.autoRef" />
            </div>
            <div class="col-lg-4">
                <strong>PRCo <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.PRCo"
                           bindLabel="PRCoNameMask"
                           [searchable]="true"
                           [clearable]="false"
                           [disabled]="employee.IsRehire"
                           (change)="pRCoChanged()"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let prCompany of prCompanies" [value]="prCompany.PRCo">{{prCompany.PRCoNameMask}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>PR Group <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.PRGroup"
                           bindLabel="PRGroupName"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let pRGroup of pRGroups" [value]="pRGroup.PRGroup">{{pRGroup.PRGroupName}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <strong>Insurance Code <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.InsCode"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of insuranceCodeList" [value]="data.InsCode">{{data.InsCode}} - {{data.Description}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <strong>Craft</strong>
                <ng-select [(ngModel)]="formData.Craft"
                           [searchable]="true"
                           [clearable]="true"
                           (change)="craftChanged()"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let craft of crafts" [value]="craft.Craft">{{craft.Craft}} - {{craft.CraftDescription}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>Class</strong>
                <ng-select [(ngModel)]="formData.Class"
                           [searchable]="true"
                           [clearable]="true"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let class of classes" [value]="class.Class">{{class.Class}} - {{class.ClassDescription}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <strong>PR Department <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.PRDept"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let department of departments" [value]="department.PRDept">{{department.PRDept}} - {{department.PRDeptDescription}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <strong>Default Earn Code <span style="color:red;">*</span></strong>
                <ng-select [(ngModel)]="formData.EarnCode"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let earnCode of earnCodes" [value]="earnCode.EarnCode">{{earnCode.EarnCode}} - {{earnCode.EarnCodeDescription}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-6">
                <strong>Occupation Category</strong>
                <ng-select [(ngModel)]="formData.OccupCat"
                           bindLabel="DisplayValue"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of occupationCat" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>

            <div class="col-lg-6">
                <strong>Position Code</strong>
                <ng-select [(ngModel)]="formData.PositionCode"
                           bindLabel="DisplayValue"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of positionCode" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-6">
                <strong>Code Series 1</strong>
                <ng-select [(ngModel)]="formData.CodeSeries1"
                           bindLabel="DisplayValue"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of acaCode1" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>

            <div class="col-lg-6">
                <strong>Code Series 2</strong>
                <ng-select [(ngModel)]="formData.CodeSeries2"
                           bindLabel="DisplayValue"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of acaCode2" [value]="data.DatabaseValue">{{data.DisplayValue}}</ng-option>
                </ng-select>
            </div>
        </div>
        <div style="margin-bottom:5px;" class="row">
            <div class="col-lg-4">
                <strong>Employment Status</strong>
                <ng-select [(ngModel)]="formData.EmploymentStatus"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of employmentStatusList" [value]="data.StatusCode">{{data.StatusCode}} - {{data.Description}}</ng-option>
                </ng-select>
            </div>

            <div class="col-lg-4">
                <strong>Local Code</strong>
                <ng-select [(ngModel)]="formData.LocalCode"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of localCodeList" [value]="data.LocalCode">{{data.LocalCode}} - {{data.Description}}</ng-option>
                </ng-select>
            </div>
            <div class="col-lg-4">
                <strong>Overtime Schedule <span style="color:red;" *ngIf="oNInitHirestoPayroll || employee.IsRehire">*</span></strong>
                <ng-select [(ngModel)]="formData.OvertimeSchedule"
                           [searchable]="true"
                           [clearable]="false"
                           dropdownPosition="bottom">
                    <ng-option *ngFor="let data of overtimeScheduleList" [value]="data.Value">{{data.Value}} - {{data.Description}}</ng-option>
                </ng-select>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div style="margin-top: 12px;">
        <div>
            <span style="padding-right:20px;" [hidden]="!processing">
                Processing {{progressCurrent}}...<img src="/Cache/images/icon_load.gif" alt="Loading..." />
            </span>
            <button type="button" class="btn btn-success" (click)="initialize()" id="FinalInitialize"
                    *ngIf="(employee.TasksCompleted != 'In Process' && employee.TasksCompleted != 'Completed')"
                    [disabled]="formData.HRCo == null || formData.hireDate == null || processing || (formData.hrRef == null && !formData.autoRef) || alert.type == 'success' || formData.Gender == null || formData.InsCode == null ||
                        (oNInitHirestoPayroll && !employee.IsRehire && !formData.autoRef && formData.PREmployee == null)
                        || formData.PRCo == null || formData.Race == null || formData.PRDept == null || formData.PRGroup == null || formData.EarnCode == null || formData.hrRefDisable || ((oNInitHirestoPayroll || employee.IsRehire) && formData.OvertimeSchedule == null)">
                Initialize
            </button>
            <button type="button" class="btn btn-outline-dark " (click)="closeClicked()" [disabled]="processing">Close</button>
        </div>
    </div>
</div>